// Unpublished Work © 2023 Deere & Company.
import t from 'tcomb';

export const DataShareSaveSuccess = t.struct({
    isRegistrySuccess: t.Boolean,
    isDBSSuccess: t.Boolean
}, {
    defaultProps: {
        isRegistrySuccess: false,
        isDBSSuccess: false
    },
    name: 'DataShareSaveSuccess',
    strict: true
});
